import { render, staticRenderFns } from "./bannerList.vue?vue&type=template&id=4f53a544&scoped=true"
import script from "./bannerList.vue?vue&type=script&lang=js"
export * from "./bannerList.vue?vue&type=script&lang=js"
import style0 from "./bannerList.vue?vue&type=style&index=0&id=4f53a544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f53a544",
  null
  
)

export default component.exports